<template>
  <section class="sale-customers-summary-card card">
    <div class="card-body sale-customers-summary-body">
      <div class="sale-customers-summary-metrics">
        <article class="sale-customers-summary-metric">
          <small>{{ text.detail.customersTab.summary.metrics.customers }}</small>
          <strong>{{ summary.customers }}</strong>
        </article>

        <article class="sale-customers-summary-metric">
          <small>{{ text.detail.customersTab.summary.metrics.averagePerCustomer }}</small>
          <strong>{{ summary.averagePerCustomer }}</strong>
        </article>

        <article class="sale-customers-summary-metric">
          <small>{{ text.detail.customersTab.summary.metrics.topIncomePerCustomer }}</small>
          <strong>{{ summary.topIncomePerCustomer }}</strong>
        </article>
      </div>

      <div v-if="canManageCustomers" class="sale-customers-summary-actions">
        <button
          type="button"
          class="app-header-btn app-header-btn--secondary"
          @click="$emit('clear')"
        >
          <i class="fa fa-eraser" aria-hidden="true"></i>
          <span>{{ text.detail.customersTab.summary.actions.clear }}</span>
        </button>

        <button
          type="button"
          class="app-header-btn app-header-btn--primary"
          @click="$emit('new-customer')"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
          <span>{{ text.detail.customersTab.summary.actions.create }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('sales');

export default {
  name: 'SaleCustomersSummary',
  props: {
    summary: {
      type: Object,
      default: () => ({
        customers: '0',
        averagePerCustomer: '$0.00',
        topIncomePerCustomer: '$0.00',
      }),
    },
    canManageCustomers: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['clear', 'new-customer'],
  data() {
    return {
      text,
    };
  },
};
</script>

<style scoped>
.sale-customers-summary-card {
  border: 1px solid rgba(153, 152, 153, 0.24);
  border-top: 2px solid #00b2e2;
  border-radius: 9px;
  box-shadow: 0 3px 12px rgba(0, 98, 163, 0.08);
  background: #ffffff;
  margin: 0;
}

.sale-customers-summary-card .sale-customers-summary-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px !important;
}

.sale-customers-summary-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0;
  flex: 1;
}

.sale-customers-summary-metric {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 8px 12px;
  min-height: 68px;
  justify-content: center;
}

.sale-customers-summary-metric small {
  color: #374151;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-weight: 600;
}

.sale-customers-summary-metric strong {
  color: #111827;
  font-size: 22px;
  font-weight: 700;
  line-height: 1;
}

.sale-customers-summary-metric:nth-child(1) strong {
  color: #0069b4;
}

.sale-customers-summary-metric:nth-child(2) strong {
  color: #7c6f64;
}

.sale-customers-summary-metric:nth-child(3) strong {
  color: #5f6368;
}

.sale-customers-summary-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.sale-customers-summary-actions .app-header-btn {
  min-height: 44px;
}

@media (max-width: 991px) {
  .sale-customers-summary-card .sale-customers-summary-body {
    flex-direction: column;
    align-items: stretch;
  }

  .sale-customers-summary-actions {
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .sale-customers-summary-metric strong {
    font-size: 17px;
  }
}

@media (max-width: 767px) {
  .sale-customers-summary-metrics {
    grid-template-columns: 1fr;
  }

  .sale-customers-summary-metric strong {
    font-size: 15px;
  }
}
</style>
